<template>
  <md-card>
    <md-card-content>
      <div class="md-layout md-gutter">
        <div
          class="md-layout-item md-size-20 md-layout md-medium-size-40 md-small-size-40 md-xsmall-size-100"
        >
          <md-field>
            <label for="stateS">Estado</label>
            <md-select v-model="stateS" name="stateS" id="stateS">
              <md-option :value="0">Sin Filtro</md-option>
              <md-option :value="c.id" v-for="c in mStates" :key="c.id">{{c.name}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { Slider, Collapse } from "@/components";
import dataService from "../../../services/catalog";

export default {
  components: {
    Slider,
    Collapse,
  },
  data() {
    return {
      responsive: false,
      // selected
      stateS: 0,
      // metadatas
      mStates: [],

      filterFunctions: [],
    };
  },
  props: {
    datasIn: Array,
  },
  methods: {
    registerFilter(filterFunction) {
      this.filterFunctions.push(filterFunction);
    },

    filterF(item) {
      for (let i in this.filterFunctions) {
        if (!this.filterFunctions[i](item)) {
          return false;
        }
      }
      return true;
    },

    consultMetas(ruta, asign, arg) {
      // Make query for metaDatas
      dataService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res;
      });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.registerFilter((element) => {
      return !this.stateS ? true : element.stateId === this.stateS;
    });

    // get metadatas
    this.consultMetas("common/states", "mStates");

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    datasOut: function () {
      this.$emit("filtered", this.datasOut);
    },
  },
  computed: {
    datasOut: function () {
      return this.datasIn.filter(this.filterF);
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/HighwayTollbooth/Filter.vue